import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getUsers = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/user/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'USER_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'USER_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const getForSelect = () => async (dispatch) => {
    dispatch({ type: 'USER_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/user/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'USER_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'USER_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'USER_NOT_LOADING' })
    }
}

export const getUser = (user) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/user/get/'+ user, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'USER_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'USER_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const addUser = (userdata) => async (dispatch) => {
    try {
        const { data, status} = await Axios.post('/api/user/register', userdata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'USER_ADD_SUCCESS',
                payload: data
            })
        } else {
            if (status === 264 || status === 260) {
                dispatch({
                    type: 'USER_WRONG_SUCCESS',
                    payload: data
                })
            }else{
                dispatch({
                    type: 'USER_NOT_LOADING'
                })
            }
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const editUser = (userdata, user) => async (dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/user/edit/' + user, userdata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'USER_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const enableUser = (idUser) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/user/enable/' + idUser, {}, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            await dispatch({
                type: 'USER_ENABLEDISABLE_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'USER_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_ERROR'
        })
    }
}

export const disableUser = (idUser) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/user/disable/' + idUser, {}, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 263 || status === 260) {
            await dispatch({
                type: 'USER_ENABLEDISABLE_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'USER_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_ERROR'
        })
    }
}

export const updateCustomProtocol = (template, idUser, tasks) => async (dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/user/updateProtocol/' + idUser, {tasks, template}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'USER_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'USER_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({ type: 'USER_NOT_LOADING' })
    }
}